package com.appsyde.shared.modules.ticket.domain.usecase

 import com.appsyde.shared.modules.ticket.domain.repository.TicketsRepository

class ListTicketsUseCase(private val repo: TicketsRepository) {
    suspend operator fun invoke(limit: Int = 50, assignedToMe: Boolean = false) =
        repo.listTickets(limit = limit, assignedToMe = assignedToMe)
}